<template>
  <div class="modal fade" id="pollModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" :class="{'modal-dialog-centered' : active != 'new'}">
      <button type="button" class="btn-close text-start d-none" data-bs-dismiss="modal" id="pollModalCloseBTN"></button>
      <div class="modal-content" v-if="active == 'new'">
        <div class="modal-body">
          <div class="alert alert-secondary">
            <h5 class="text-center" style="font-size:18px">سفارشت چطور بود؟</h5>
            <h5 class="text-center mt-1" style="font-size:18px">نظرت برامون ارزشمنده</h5>
          </div>          
          <form required>
              <div class="item-star">
                <small class="d-block text-center mt-1">به سفارشت چند ستاره میدی؟</small>
                <div class="text-center mt-2">
                  <i class="bi bi-2x fa-star mr-1" :style="{ color: hole.five.color }" aria-hidden="true" @click="addStar(5)"></i>
                  <i class="bi bi-2x fa-star mr-1" :style="{ color: hole.four.color }" aria-hidden="true" @click="addStar(4)"></i>
                  <i class="bi bi-2x fa-star mr-1" :style="{ color: hole.three.color }" aria-hidden="true" @click="addStar(3)"></i>
                  <i class="bi bi-2x fa-star mr-1" :style="{ color: hole.two.color }" aria-hidden="true" @click="addStar(2)"></i>
                  <i class="bi bi-2x fa-star mr-1" :style="{ color: hole.one.color }" aria-hidden="true" @click="addStar(1)"></i>
                </div>

              <div class="text-center mt-2" :class="{'visible':starText,'invisible':!starText }"><span class="px-1 bg-light rounded">{{ starText }}</span></div>
            </div>
            <div class="item-assessment mt-2">
              <h5 class="text-center ">بنظرت هر قسمت چطور بود؟</h5>
              <div class="assessment-plan mb-1">
                <div class="mb-3 mt-3 d-flex justify-content-between">
                  <label>خدمات فروشگاه</label>
                  <div class="d-flex gap-1 flex-wrap">
                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-1" type="radio" name="servicesRadioBTN" id="servicesRadioBTN1" value="1">
                      <label class="form-check-label" for="servicesRadioBTN1">
                        خوب
                      </label>
                    </div>

                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-2" type="radio" name="servicesRadioBTN" id="servicesRadioBTN2" value="2">
                      <label class="form-check-label" for="servicesRadioBTN2">
                        متوسط
                      </label>
                    </div>

                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-3" type="radio" name="servicesRadioBTN" id="servicesRadioBTN3" value="3">
                      <label class="form-check-label" for="servicesRadioBTN3">
                        ضعیف
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="assessment-plan mb-1">
                <div class="mb-3 mt-3 d-flex justify-content-between">
                  <label>پیک</label>
                  <div class="d-flex gap-1 flex-wrap">
                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-1" type="radio" name="peykRadioBTN" id="peykRadioBTN1" value="1">
                      <label class="form-check-label" for="peykRadioBTN1">
                        خوب
                      </label>
                    </div>

                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-2" type="radio" name="peykRadioBTN" id="peykRadioBTN2" value="2">
                      <label class="form-check-label" for="peykRadioBTN2">
                        متوسط
                      </label>
                    </div>

                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-3" type="radio" name="peykRadioBTN" id="peykRadioBTN3" value="3">
                      <label class="form-check-label" for="peykRadioBTN3">
                        ضعیف
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="assessment-plan mb-1">
                <div class="mb-3 mt-3 d-flex justify-content-between">
                  <label>بسته بندی</label>
                  <div class="d-flex gap-1 flex-wrap">
                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-1" type="radio" name="pakingRadioBTN" id="pakingRadioBTN1" value="1">
                      <label class="form-check-label" for="pakingRadioBTN1">
                        خوب
                      </label>
                    </div>

                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-2" type="radio" name="pakingRadioBTN" id="pakingRadioBTN2" value="2">
                      <label class="form-check-label" for="pakingRadioBTN2">
                        متوسط
                      </label>
                    </div>

                    <div class="form-check d-flex gap-1">
                      <input class="form-check-input item-btn-3" type="radio" name="pakingRadioBTN" id="pakingRadioBTN3" value="3">
                      <label class="form-check-label" for="pakingRadioBTN3">
                        ضعیف
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-present mt-2">
              <small style="font-weight: bold;">با ثبت نظرت کمک کن تا ما و دیگر اعضای خانواده راداَپ تصمیم بهتری بگیریم.</small>
              <div class="d-flex justify-content-between align-items-center">
                <div class="w-100 mb-2">
                  <button class="btn btn-light p-1 mx-1" v-for="item in texts" :key="item.id" @click="setText($event,item.id)" style="font-size: 12px;">{{ item.title }}</button>
                </div>
                <div v-if="poll.present.length" @click="poll.present = ''" class="d-flex align-items-center pl-1 text-danger" style="font-size:14px">
                  <i class="bi  bi-x pl-1" ></i><small style="width:max-content">پاک کردن</small>
                </div>
              </div>
              <div>
                <textarea class="form-control p-1" id="presentInput" v-model="poll.present" rows="2"
                  placeholder="احساس رضایت یا عدم رضایت یا پیشنهاد خودت رو با ما در میون بذار ..."></textarea>
              </div>
            </div>
            <div class="item-btn mt-3 text-start">
              <button v-if="!finallFlag" type="submit" class="btn btn-success w-100" @click="submitPoll($event)">ثبت نظر</button>
              <button v-if="finallFlag" class="btn btn-success w-100 " disabled>
                    <div class="spinner-border text-light" role="status" style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    لطفا شکیبا باشید
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-content" v-if="active == 'exist'">
        <h6 class="text-center p-4" style="font-weight: 600;color:#06084b">شما قبلا در این نظر سنجی شرکت کرده اید.</h6>
        <button @click="goHome" class="btn btn-success w-50 mx-auto mb-2" >متوجه شدم</button>

      </div>
        <Transition name="bounce">
          <div class="modal-content"  v-if="active == 'complete' && show" >
              <p class="text-center pt-3 p-2 h5 rounded" style="color: #b93131;font-weight: 600;">{{ convertToPersian(String(30))}} امتیاز بدست آوردید. </p>
              <button @click="goHome" class="btn btn-light w-50 mx-auto mb-2" style="border-color: rgb(0 0 0 / 40%)">متوجه شدم</button>
          </div>
        </Transition>
      <div class="modal-content" v-if="active == ''" >
        <h6 class="text-center p-4" style="font-weight: 600;">لطفا چند لحظه صبر کنید...</h6>
      </div>
    </div>

  </div>
</template>
<script setup>
import { reactive, ref,computed,watch } from 'vue';
import { useRoute,useRouter } from 'vue-router';
import { convertToPersian } from '@/composables/digits';
import { alertBox } from '@/composables/silverBox';
let route = useRoute();
let router = useRouter();
let starColor = reactive({
  one : '#c13024',
  two : '#c47617',
  three : '#d59916',
  four : '#d0c111',
  five : '#dffc45'
});
let finallColor = ref('#e7e732');
let starText = ref('');
let pre_id = ref()
let state = ref()
let finallFlag = ref(false)
let show = ref(false)
let active = ref('')
let descriptionTemp = ref('')
let poll = reactive({
  star: 'a0',
  service: [0, 0, 0],
  present: ''
});
let hole = reactive({
  one: { 'color': starColor.one, 'value': 'خیلی بد' },
  two: { 'color': starColor.two, 'value': 'بد' },
  three: { 'color': starColor.three, 'value': 'متوسط' },
  four: { 'color': starColor.four, 'value': 'خوب' },
  five: { 'color': starColor.five, 'value': 'عالی' }
})
let texts = ref([
                  {
                    id : 1,
                    title : 'کیفیت',
                    txt : ' واقعاً از کیفیت سفارشم راضی هستم، متشکرم. '
                  },
                  {
                    id : 2,
                    title : 'عدم کیفیت',
                    txt : ' این سفارش باب میلم نبود. '
                  },
                  {
                    id : 3,
                    title : 'ارسال به موقع',
                    txt : ' سفارشم خیلی سریع و به موقع به دستم رسید. '
                  },
                  {
                    id : 4,
                    title : 'تاخیر',
                    txt : ' متاسفانه سفارشم با کمی تاخیر ارسال شد.'
                  }
      ]);
const page = computed(() => route.name);
watch(page, async () => {
  if(route.name == 'Poll'){
    await getState();
  }else{
    if(document.getElementById('pollModalCloseBTN')){
      document.getElementById('pollModalCloseBTN').click()
    }
  }
}, { immediate: true });

function setText(e,id){
  e.preventDefault()
  let item = texts.value.find(item => item.id == id);
  if(!poll.present.includes(item.txt)){
    poll.present += item.txt
  }
}
async function getState() {
  let response = await fetch('https://radap.ir/Backend/api/section/survay/getState.php?pre_id=' + route.params.id)
  let data = await response.json()
      pre_id.value = data.pre_id;
      state.value = data.state;
      if (state.value > 1) {
        active.value = 'exist'
      } else {
        active.value = 'new'
      }
}
async function submitPoll(e) {
  finallFlag.value = true
  e.preventDefault()
  if (document.querySelector('input[name="servicesRadioBTN"]:checked') != null) {
    poll.service[0] = document.querySelector('input[name="servicesRadioBTN"]:checked').value
  } else {
    poll.service[0] = 'a0'
  }
  if (document.querySelector('input[name="peykRadioBTN"]:checked') != null) {
    poll.service[1] = document.querySelector('input[name="peykRadioBTN"]:checked').value
  } else {
    poll.service[1] = 'a0'
  }
  if (document.querySelector('input[name="pakingRadioBTN"]:checked') != null) {
    poll.service[2] = document.querySelector('input[name="pakingRadioBTN"]:checked').value
  } else {
    poll.service[2] = 'a0'
  }
  let txt = poll.present.trim() 
  if (txt == '') {
    txt = 'a-'
  }

  let response = await fetch(`https://radap.ir/Backend/api/section/survay/set.php?pre_id=${pre_id.value}&star=${poll.star}&service=${poll.service}&present=${txt}`)
  let data = await response.text()
    if(data == 'null'){
      finallFlag.value = false
      if(poll.star == 'a0'){
        alertBox('لطفا به خریدتان ستاره بدهید');
      }else{
        alertBox('لطفا حداقل یک مورد را انتخاب نمایید');
      }
    }else{
      active.value = 'complete'
      show.value = true
    }
}
function addStar(several) {
  staring(several)
  poll.star = several;
}
function staring(several) {
  hole.one.color = "rgb(120 120 120)";
  hole.two.color = "rgb(120 120 120)";
  hole.three.color = "rgb(120 120 120)";
  hole.four.color = "rgb(120 120 120)";
  hole.five.color = "rgb(120 120 120)";
  starText.value = '';
  switch (several) {
    case 1:
      hole.one.color = finallColor.value;
      starText.value = hole.one.value;
      break;
    case 2:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      starText.value = hole.two.value;
      break;
    case 3:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      hole.three.color = finallColor.value;
      starText.value = hole.three.value;
      break;
    case 4:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      hole.three.color = finallColor.value;
      hole.four.color = finallColor.value;
      starText.value = hole.four.value;
      break;
    case 5:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      hole.three.color = finallColor.value;
      hole.four.color = finallColor.value;
      hole.five.color = finallColor.value;
      starText.value = hole.five.value;
      break;
    default:
      break;
  }
}
function goHome(){
  document.getElementById('pollModalCloseBTN').click()
  router.push('/')
}
</script>
<style scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
textarea::placeholder{
  font-size: 14px;
}
.item-btn-1:checked{
  background-color: green;
  border-color: green;
}
.item-btn-2:checked{
  background-color: #d7d72a;
  border-color: #d7d72a;
}
.item-btn-3:checked{
  background-color: red;
  border-color: red;
}
</style>
